export default {
  userAddedProductToInventory: '{creator} added product {product} to inventory',
  userIncreasedProductInInventory:
    '{creator} increased capacity of product {product}',
  userDeductedProductFromInventory:
    '{creator} deducted product {product} from inventory',
  productDeductedByFactor:
    'product {product} deducted from inventory via invoice number {invoice}',
  userCreatedWarehouse: '{creator} created warehouse {warehouse}',
  userUpdatedWarehouse: '{creator} updated {field} of warhouse to {value}',
};
